module.exports = __webpack_public_path__ + "static/img/dynamic.cedce131.svg";